"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobMediaFile = void 0;
const typeorm_1 = require("typeorm");
const decorators_1 = require("../data-ui/decorators");
const layouts_1 = require("../data-ui/layouts");
const job_1 = require("./job");
const contact_profile_enum_1 = require("./contact-profile-enum");
const job_media_file_enum_1 = require("./job-media-file-enum");
let JobMediaFile = class JobMediaFile {
};
JobMediaFile.SFID_PREFIX = 'a2N';
JobMediaFile.NAME_PREFIX = 'JMF';
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    decorators_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", Number)
], JobMediaFile.prototype, "id", void 0);
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        length: 18,
        name: 'sfid',
        default: () => "gid_generate_sfid('a2N')",
        unique: true,
        nullable: false,
    }),
    __metadata("design:type", String)
], JobMediaFile.prototype, "sfid", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 255,
        nullable: true,
        name: 'api_id__c',
        unique: true,
    }),
    __metadata("design:type", String)
], JobMediaFile.prototype, "apiId", void 0);
__decorate([
    decorators_1.DataUi.SearchField(),
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)('varchar', {
        nullable: false,
        name: 'name',
        length: 80,
        default: () => "gid_generate_name('JMF', 6)",
    }),
    __metadata("design:type", String)
], JobMediaFile.prototype, "name", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('public.hc_idx_job_media_files__c_job__c'),
    (0, typeorm_1.Column)('varchar', {
        nullable: true,
        name: 'job__c',
        length: 18,
    }),
    __metadata("design:type", String)
], JobMediaFile.prototype, "jobSfid", void 0);
__decorate([
    (0, typeorm_1.Index)('public.hc_idx_job_media_files__c_job__r__api_id__c'),
    (0, typeorm_1.Column)('varchar', {
        nullable: true,
        name: 'job__r__api_id__c',
        length: 18,
    }),
    __metadata("design:type", String)
], JobMediaFile.prototype, "jobApiId", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('public.hc_idx_job_media_files__c_version__c'),
    (0, typeorm_1.Column)({
        type: 'float8',
        name: 'version__c',
        nullable: false,
    }),
    __metadata("design:type", Number)
], JobMediaFile.prototype, "version", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'float8',
        name: 'index__c',
        nullable: false,
    }),
    __metadata("design:type", Number)
], JobMediaFile.prototype, "index", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    decorators_1.DataUi.S3File({
        name: (i, index) => `jmf/${i.generatedId}`,
        arrayMode: 'append',
        fullUrl: false,
    }),
    (0, typeorm_1.Column)('varchar', {
        nullable: false,
        name: 'path__c',
        length: 255,
    }),
    __metadata("design:type", String)
], JobMediaFile.prototype, "path", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('public.hc_idx_job_media_files__c_type__c'),
    (0, typeorm_1.Column)({
        name: 'type__c',
        length: 255,
        default: job_media_file_enum_1.JobMediaFileTypeEnum.PICTURE,
    }),
    __metadata("design:type", String)
], JobMediaFile.prototype, "type", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.CreateDateColumn)({
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], JobMediaFile.prototype, "createdAt", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('public.hc_idx_job_media_files__c_lastmodifieddate'),
    (0, typeorm_1.UpdateDateColumn)({
        name: 'lastmodifieddate',
    }),
    __metadata("design:type", Date)
], JobMediaFile.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Index)('hc_idx_job_media_files__c_systemmodstamp'),
    (0, typeorm_1.Column)('timestamp', {
        nullable: true,
        name: 'systemmodstamp',
    }),
    __metadata("design:type", Date)
], JobMediaFile.prototype, "systemmodstamp", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('hc_idx_job_media_files__c_job__r__api_id__c'),
    (0, typeorm_1.ManyToOne)((type) => job_1.Job, (job) => job.files),
    (0, typeorm_1.JoinColumn)({ name: 'job__c', referencedColumnName: 'id' }),
    __metadata("design:type", job_1.Job)
], JobMediaFile.prototype, "job", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.DeleteDateColumn)({
        type: 'timestamp with time zone',
        nullable: true,
        name: 'deleted_at',
    }),
    __metadata("design:type", Date)
], JobMediaFile.prototype, "deletedAt", void 0);
JobMediaFile = __decorate([
    decorators_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    decorators_1.DataUi.Name({
        name: 'Job Media Files',
    }),
    decorators_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('job_media_files__c', { schema: 'public', synchronize: true })
], JobMediaFile);
exports.JobMediaFile = JobMediaFile;
//# sourceMappingURL=job-media-file.js.map